import classNames from "classnames";
import React from "react";

import { useSelector } from "../../utils/hooks";

import "./BoughtProduct.scss";

const BoughtProduct = () => {
	const products = useSelector((state) => state.popup.products);

	const boughtProducts = products?.chosenProducts
		.concat(products?.mainProduct)
		.reverse();

	const chosenProduct = boughtProducts[0];

	if (!chosenProduct?.productId) {
		return null;
	}

	return (
		<section
			className={classNames({
				"addtocart-productslist": true,
				"product-slim": true,
			})}
		>
			<div className="addtocart-productslist__photo-container">
				<img
					data-testid="product-image"
					src={products.mainProduct.imgUrl}
					alt={products.mainProduct.productName}
					className="addtocart-productslist__photo"
				/>
			</div>
			<p className="addtocart-product__name">
				<a
					href={chosenProduct.url}
					target="_blank"
					data-testid="product-name"
					rel="noreferrer"
				>
					{chosenProduct.productName}
				</a>
				<span>{chosenProduct.description}</span>
			</p>
			<p data-testid="product-price" className="addtocart-product__price">
				{chosenProduct.price}
			</p>
		</section>
	);
};

export default BoughtProduct;
